'use strict';

angular.module('homeController', [])

.controller('HomeController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window', '$q', '$interval', '$timeout', 'PropertyService', 'SellerService', 'ContactService', 'AgentService', 'FeedService'
    ,function (appInfo, $scope, $rootScope, $log, $location, $window, $q, $interval, $timeout, PropertyService, SellerService, ContactService, AgentService, FeedService) {
    var ekey = $rootScope.currentUser.authdata;

    $scope.polling = false;
    $scope.newItems = false;

    $rootScope.header.style = "display";
    $rootScope.header.show = true;

    // $scope.feedServ = new FeedService.Feed;

    // var checkItemExists = function(item) {
    //     var itemExists = false;
    //     angular.forEach($scope.feedServ.items, function(feedItem){
    //         if(item.id !== feedItem.id) {
    //             itemExists = true;
    //         }
    //     });

    //     return itemExists;
    // }

    // var poll = function() {
    //     // Don't start a new poll if we are already polling
    //     if ( $scope.polling ) return;

    //     $scope.polling = true;
    //     angular.element('.ui.feed').attr('infinite-scroll-disabled', true);
        
    //     FeedService.checkSellerFeed(10, 0).then(function(response){
    //         var newItems = [];
    //         response.reduce(function(p, val) { 
    //             return p.then(function() {
    //                 var duplicateItem = checkItemExists(val);

    //                 if(!duplicateItem) {
    //                      newItems.push(val);
    //                 }
    //             });
    //         }, $q.when(true)).then(function() {
    //             // Finished
    //             if(newItems.length > 0) {
    //                 $scope.newItems = true;

    //                 angular.forEach(newItems, function(item){
    //                     $scope.feedServe.items.splice(0, 1, item);
    //                 });
    //             }
    //         }).finally(function(){
    //             $scope.polling = false;
    //              angular.element('.ui.feed').attr('infinite-scroll-disabled', false);
    //         });
    //     });
    // }

    // var setupListing = function(ref) {
    //     $rootScope.loading = true;  //Start the spinner
    //     $rootScope.currentListing.notifications = { mail:0, appointments:0, offers: 0 };

    //     SellerService.property(ekey, ref).then(function(response) {
    //         var result = {};

    //         //Start Mail
    //         result.messages = []; 
    //         angular.forEach(response.communication, function (com) {

    //             // Message in inbox
    //             if(typeof com.toRef.seller !== 'undefined') {
    //                 var promise = ContactService.contact(ekey, com.fromRef.agent);

    //                 if(com.read == 0 ) {
    //                     $rootScope.currentListing.notifications.mail++;
    //                 }

    //                 promise.then(function(response) {
    //                   com.from = response.result[0];
    //                 });
    //             }

    //             // Message in sent history
    //             if(typeof com.toRef.agent !== 'undefined') {
    //                 var promise = ContactService.contact(ekey, com.toRef.agent);

    //                 promise.then(function(response) {
    //                   com.to = response.result[0];
    //                 });
    //             }

    //             result.messages.push(com);
    //         });

    //         //Start Tasks
    //         result.appointments = []; 
    //         angular.forEach(response.appointments, function (apt) {
    //             AgentService.getAgent(apt.agentId).then(function(response) {
    //                 agent = response.result[0];
    //             }).then(function(response) {
    //                 var active = false;
                    
    //                 if(apt.ends > appInfo.today) {
    //                     active = true;
    //                     $rootScope.currentListing.notifications.appointments++;
    //                 }
                    
    //                 var feedback = [];

    //                 switch(apt.type){
    //                     case 'Seller Visit':
    //                         apt.type = "Agent Visit";
    //                         break;
    //                     case 'buyers':
    //                         apt.type = "Buyer Appointment";
    //                         break;
    //                     case 'open home':
    //                         apt.type = "Open Inspection";
    //                         break;
    //                 }

    //                 angular.forEach(apt.feedback, function(fb) {
    //                     //Divide rating by 2 to display on five star directive
    //                     fb.rate = parseInt(fb.rank) / 2;
    //                     //If no feedback set up strike through
    //                     fb.strike = (fb.priceOpinion == 9999999)? true : false;
    //                 });

    //                 apt.label   = apt.type;
    //                 apt.cls     = apt.type.toLowerCase().replace(" ", "-");
    //                 apt.active  = active;
    //                 apt.str     = moment.unix(apt.starts).format('LLLL');
    //                 apt.day     = moment.unix(apt.starts).format('DD');
    //                 apt.month   = moment.unix(apt.starts).format('MMM');
    //                 apt.start   = moment.unix(apt.starts).format('h:mm a');
    //                 apt.end     = moment.unix(apt.ends).format('h:mm a');
    //                 apt.agent   = agent;
    //                 apt.count   = apt.feedback.length;
    //                 apt.feedback= apt.feedback;

    //                 result.appointments.push(apt);
    //             });
    //          });
            
    //         //Start Offers
    //         result.offers = []; 
    //         angular.forEach(response.offers, function (offers) {
    //             if(offers.category == "B" ) {
    //                 $rootScope.currentListing.notifications.offers++;
    //                 result.offers.push(offers);
    //             }
    //          });

    //         $rootScope.currentListing.data = result;

    //     }).then( function (){
    //         //Get Listing Image
    //         PropertyService.getListingImage(ref).then(function(rs){
    //             $rootScope.currentListing.image = rs;
    //         });

    //         //Stop loader
    //         $rootScope.loading = false;
    //     });
    // }

    $scope.showNewItems = function() {
        $window.scrollTo(0, angular.element('.feed').offsetTop);  
        $scope.newItems = !$scope.newItems;
    }

    var init = function() {
        // If this is a fresh login, find the users active properties
        // if($rootScope.authload) {
        //     $rootScope.currentUser.listings = [];

        //     SellerService.listings(ekey).then(function(response) {
        //         if(response.length == 0){
        //             $window.alert('Cannot find any active properties. Please contact your Wiseberry agent.');
        //             $location.path('/login');
        //         }

        //         angular.forEach(response, function(rs) {
        //             var obj = { 
        //                 address:rs.address, 
        //                 streetUnit: rs.streetUnit,
        //                 streetRef: rs.streetRef,
        //                 streetName: rs.streetName,
        //                 streetType: rs.streetType,
        //                 location: rs.location,
        //                 postcode: rs.postcode,
        //                 propertyRef:rs.property, 
        //                 agentRef:rs.agentRef ,
        //                 sellerRef:rs.sellerRef, 
        //                 agentInfo: rs.agentInfo.result[0]

        //             };
        //             $rootScope.currentUser.listings.push(obj);
        //         });

        //         // Make the first listing the active one 
        //         $rootScope.currentListing = $rootScope.currentUser.listings[0];

        //     }).finally(function(){
        //         $rootScope.authload = false;
        //         setupListing($rootScope.currentListing.propertyRef);

        //         // Start polling the feed
        //         $interval(function() {
        //             poll();
        //         }, 100000, true);
        //     });
        // } else {
        //     // Recheck listing details and notifications
        //     setupListing($rootScope.currentListing.propertyRef);
        // }     
    };

    init();

}]);